var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBumpUp(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.315,
    height: 16.083,
    viewBox: "0 0 17.315 16.083",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_18642",
    "data-name": "Group 18642",
    transform: "translate(-7.685 -7.502)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2458",
    "data-name": "Rectangle 2458",
    width: 16,
    height: 3,
    rx: 1.5,
    transform: "translate(9 7.502)",
    fill: "#fb3640"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_23",
    "data-name": "Subtraction 23",
    d: "M21004.605,20703.369h-8a.974.974,0,0,1-.268-.035l-.662-.59a1,1,0,0,1,.93-1.373h8a1,1,0,1,1,0,2Z",
    transform: "translate(-20980.607 -20688.869)",
    fill: "#f7646b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union_24",
    "data-name": "Union 24",
    d: "M4.159,11.587a1,1,0,0,1-1-1V5.17H1.132A1,1,0,0,1,.455,3.434L3.856.3A1,1,0,0,1,5.212.3l3.4,3.139A1,1,0,0,1,7.935,5.17H5.909v5.417a1,1,0,0,1-1,1Z",
    transform: "translate(7.555 11.998)",
    fill: "#fb3640"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_22",
    "data-name": "Subtraction 22",
    d: "M21003.641,20706.336h-8a1.041,1.041,0,0,1-.16-.014,1.247,1.247,0,0,0,.994-.512,1.859,1.859,0,0,0,.035-1.479h7.127a1,1,0,0,1,0,2Z",
    transform: "translate(-20979.643 -20688.832)",
    fill: "#f87d83"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2468",
    "data-name": "Rectangle 2468",
    width: 10,
    height: 2,
    rx: 1,
    transform: "translate(15 18.502)",
    fill: "#f8a1a5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2469",
    "data-name": "Rectangle 2469",
    width: 10,
    height: 2,
    rx: 1,
    transform: "translate(15 21.502)",
    fill: "#f8aeb2"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBumpUp);
export default __webpack_public_path__ + "static/media/bump-up.78ff6b55f2c9aecd1d65354ccf895006.svg";
export { ForwardRef as ReactComponent };